var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-1",staticStyle:{"padding-bottom":"5px"}},[_c('v-card-title',{staticClass:"card-title"},[_vm._v(" Drug Screening ")]),_c('v-card-text',[_c('div',{attrs:{"id":_vm.divId}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }